import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./users_profile.css";


function UpdateUserProfile({ profileId, setUpdateTrigger, updateTrigger, setShowUpdateUserProfile }) {

  const [modules, setModules] = useState([]);
  const [profileName, setProfileName] = useState("");
  const [permissions, setPermissions] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);

  const profileRef = useRef(null);

  const getProfileData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/user_profiles/edit/${profileId}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.status === 200) {
        const data = res.data.data;

        // Si el backend devuelve { profileName, list_permissions: [] }
        const { profileName, list_permissions } = data;

        // Seteamos el nombre del perfil
        setProfileName(profileName || "");

        const modulesData = list_permissions;
        setModules(modulesData);
        const initialPermissions = {};
        modulesData.forEach((module) => {
          // Usa el valor real de permiso si viene del backend
          initialPermissions[`${module.m_id}-${module.s_id}`] = module.permission || 1;
        });
        setPermissions(initialPermissions);
      } else {
        Swal.fire("Error", "No se pudieron cargar los datos del perfil", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error al obtener los datos del perfil", "error");
    }
  };

  const handleRadioChange = async (m_id, s_id, hasAccess) => {
    setPermissions(prev => ({
      ...prev,
      [`${m_id}-${s_id}`]: hasAccess
    }));
  };

  const createEntries = async () => {
    if (!profileName) {
      profileRef.current.focus();
      return;
    }

    setIsUpdating(true); 

    const dataToSend = {
      name: profileName,
      permissions: modules.map((module) => ({
        menu_module_id: module.m_id,
        menu_sub_module_id: module.s_id === "-" ? 0 : module.s_id,
        permission: permissions[`${module.m_id}-${module.s_id}`] || 1,
      })),
    };


    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/user_profiles/update/${profileId}`,
        dataToSend,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.status === 200) {
        Swal.fire("Éxito", "Perfil creado actualizado.", "success");
        setUpdateTrigger(!updateTrigger);
        setShowUpdateUserProfile(false);
        setIsUpdating(false);
      } else {
        Swal.fire("Error", "Hubo un error al crear el perfil", "error");
        setIsUpdating(false);
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error al crear el perfil", "error");
      setIsUpdating(false);
    }
  };

  useEffect(() => {
    if (profileId) {
      getProfileData();
    }
  }, [updateTrigger, profileId]);

  return (
    <div>

      <div>
        <div className="col-lg-11 create-input mb-2">
          <span className="bold">Perfil *</span>
        </div>
        <div className="mb-3 create-input col-lg-4">
          <input
            className="form-control form-control-sm"
            value={profileName}
            onChange={(e) => setProfileName(e.target.value)}
          />
        </div>
      </div>
      <div className="permissions-table-parent">

        <table
          className="table table-inverse table-hover table-striped table-bordered permissions-table no-footer"
        >          <thead>
            <tr>
              <th>Módulo</th>
              <th>Sin Acceso</th>
              <th>Con Acceso</th>
            </tr>
          </thead>
          <tbody>
            {modules.map((module) => (
              <tr key={module.id} data-master-id={module.id}>
                <td>{module.module}</td>
                <td className="radio-center">
                  {/* SIN ACCESO → permission = 1 */}
                  <input
                    type="radio"
                    name={`access-${module.m_id}-${module.s_id}`}
                    checked={permissions[`${module.m_id}-${module.s_id}`] === 1 || !permissions[`${module.m_id}-${module.s_id}`]}
                    onChange={() => handleRadioChange(module.m_id, module.s_id, 1)}
                    value="1"
                  />
                </td>
                <td className="radio-center">
                  {/* CON ACCESO → permission = 4 */}
                  <input
                    type="radio"
                    name={`access-${module.m_id}-${module.s_id}`}
                    checked={permissions[`${module.m_id}-${module.s_id}`] === 4}
                    onChange={() => handleRadioChange(module.m_id, module.s_id, 4)}
                    value="4"
                  />
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="text-right r my-2">
        <button className="btnn" onClick={createEntries} disabled={isUpdating}>
          Guardar
        </button>
      </div>
    </div>
  );
}

export default UpdateUserProfile;
